module.exports = __webpack_public_path__ + "media/images/flags/4x3/wal-a154b14325a06f4955d507aac190ec63.svg";